export default "__VITE_ASSET__Cco5BN8z__"